import React, { Component, useEffect, useState } from 'react';
import { array, bool, func, oneOf, object, shape, string } from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import debounce from 'lodash/debounce';
import unionWith from 'lodash/unionWith';
import classNames from 'classnames';
import config from '../../config';
import { v4 as uuidv4 } from 'uuid';
import { ReactComponent as CloseIcon } from '../../assets/svg/close.svg';
import { ReactComponent as DownArrow } from '../../assets/svg/arrowDown.svg';
import { ReactComponent as VerifiedTickComponent } from '../../assets/svg/verifiedBatch.svg';

import routeConfiguration from '../../routeConfiguration';
import { createResourceLocatorString, pathByRouteName } from '../../util/routes';
import { createSlug, parse, stringify } from '../../util/urlHelpers';
import { propTypes } from '../../util/types';
import { getListingsById, getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/UI.duck';
import * as validators from '../../util/validators';
// import { ReactComponent as CloseIcon } from '../../assets/svg/close.svg';
const textfield = 'textfield';
const errorTextField = 'errorTextField';
import {
  SearchMap,
  ModalInMobile,
  Page,
  LayoutSideNavigation,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  Footer,
  LayoutWrapperSideNav,
  LayoutWrapperMain,
  AvatarLarge,
  PaginationLinks,
  Modal,
  FieldRadioButton,
  CustomRadioButton,
  Form,
  FieldCheckbox,
  FieldCustomSelect,
  FieldWorkerJobCategory,
  FieldAddress,
  FieldTextInput,
  FieldLanguagesKnown,
  Button,
  PrimaryButton,
  PriceFilter,
  FieldNumberInput,
  NamedLink,
  IconSpinner,
} from '../../components';
import { TopbarContainer } from '../../containers';

import { searchListings, setActiveListing } from './SearchPage.duck';
import {
  pickSearchParamsOnly,
  validURLParamsForExtendedData,
  validFilterParams,
  createSearchResultSchema,
} from './SearchPage.helpers';
import MainPanel from './MainPanel';
import { ReactComponent as ThankYou } from '../../assets/svg/thankyou.svg';
import { ReactComponent as Location } from '../../assets/svg/locationPin.svg';
import { ReactComponent as FavouriteIcon } from '../../assets/svg/favourites.svg';
import { ReactComponent as Verified } from '../../assets/svg/verified.svg';
import arrayMutators from 'final-form-arrays';

import css from './SearchPage.module.css';
import SearchIcon from '../../components/Topbar/SearchIcon';
import { BiSearch } from 'react-icons/bi';
import { findOptionsByFilterLabel, findOptionsForSelectFilter } from '../../util/search';
import moment from 'moment';
import { formatMoney, unitDivisor } from '../../util/currency';
import { Form as FinalForm } from 'react-final-form';
import { values } from 'lodash';
import { locationBounds } from '../../components/LocationAutocompleteInput/GeocoderMapbox';
import { types as sdkTypes } from '../../util/djobTypes';
import { ReactComponent as NoMatchFound } from '../../assets/svg/noMatchFound.svg';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import ListingCardCustom from '../../components/ListingcardCustom/ListingCardCustom';
import CopyToClipBoard from '../../components/Copy/CopyToClipBoard';
import WorkerDashboardSideWrapper from '../../components/WorkerDashboardSideWrapper/WorkerDashboardSideWrapper';

const MODAL_BREAKPOINT = 768; // Search is in modal on mobile layout
const SEARCH_WITH_MAP_DEBOUNCE = 300; // Little bit of debounce before search is initiated.
const { LatLng } = sdkTypes;

export class SearchPageComponent extends Component {
  constructor(props) {
    super(props);
    const { tab } = parse(props.location.search);

    this.state = {
      isSearchMapOpenOnMobile: props.tab === 'map',
      isMobileModalOpen: false,
      currentTab: tab || 'MostRecent',
      isAdvanceModalOpen: false,
      modalSubCategoryOpt: [],
      modalSubCategoryOptTwo: [],
      searchInput: '',
      cancelBtnClick: false,
      currentUserFavourites: null,
      favlist: [],
      asideDetailShow: false,
      clearLanguageSearch: false,
    };

    this.searchMapListingsInProgress = false;

    this.onMapMoveEnd = debounce(this.onMapMoveEnd.bind(this), SEARCH_WITH_MAP_DEBOUNCE);
    this.onOpenMobileModal = this.onOpenMobileModal.bind(this);
    this.onCloseMobileModal = this.onCloseMobileModal.bind(this);
    this.handleAdvanceSubmit = this.handleAdvanceSubmit.bind(this);
  }
  componentDidMount() {
    const search = parse(this.props.location.search);

    if (search?.keywords) {
      this.setState({ searchInput: search?.keywords });
    } else {
      this.setState({ searchInput: '' });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const search = parse(this.props.location.search);
    const prevSearch = parse(prevProps.location.search);

    // Sidebar "Djobs disponibles" links here without ?tab= — inject a default tab but
    // keep keywords/filters so the search bar keeps working after a query is submitted.
    if (!search.tab) {
      this.props.history.replace(
        createResourceLocatorString('SearchPage', routeConfiguration(), {}, {
          ...search,
          tab: 'MostRecent',
        })
      );
      return;
    }

    if (search.tab !== prevSearch.tab && search.tab !== this.state.currentTab) {
      this.setState({ currentTab: search.tab });
    }

    if (search?.keywords !== prevSearch?.keywords) {
      this.setState({ searchInput: search?.keywords || '' });
    }

    if (prevState.modalSubCategoryOpt !== this.state.modalSubCategoryOpt) {
      this.setState({ modalSubCategoryOptTwo: this.state.modalSubCategoryOpt });
    }
  }

  handleAdvanceSubmit() {
    // console.log(555);
  }

  // Callback to determine if new search is needed
  // when map is moved by user or viewport has changed
  onMapMoveEnd(viewportBoundsChanged, data) {
    const { viewportBounds, viewportCenter } = data;

    const routes = routeConfiguration();
    const searchPagePath = pathByRouteName('SearchPage', routes);
    const currentPath =
      typeof window !== 'undefined' && window.location && window.location.pathname;

    // When using the ReusableMapContainer onMapMoveEnd can fire from other pages than SearchPage too
    const isSearchPage = currentPath === searchPagePath;

    // If mapSearch url param is given
    // or original location search is rendered once,
    // we start to react to "mapmoveend" events by generating new searches
    // (i.e. 'moveend' event in Mapbox and 'bounds_changed' in Google Maps)
    if (viewportBoundsChanged && isSearchPage) {
      const { history, location, filterConfig } = this.props;

      // parse query parameters, inchandleAdvanceSubmitluding a custom attribute named certificate
      const { address, bounds, mapSearch, ...rest } = parse(location.search, {
        latlng: ['origin'],
        latlngBounds: ['bounds'],
      });

      //const viewportMapCenter = SearchMap.getMapCenter(map);
      const originMaybe = config.sortSearchByDistance ? { origin: viewportCenter } : {};

      const searchParams = {
        address,
        ...originMaybe,
        bounds: viewportBounds,
        mapSearch: true,
        ...validFilterParams(rest, filterConfig),
      };

      history.push(createResourceLocatorString('SearchPage', routes, {}, searchParams));
    }
  }

  // Invoked when a modal is opened from a child component,
  // for example when a filter modal is opened in mobile view
  onOpenMobileModal() {
    this.setState({ isMobileModalOpen: true });
  }

  // Invoked when a modal is closed from a child component,
  // for example when a filter modal is opened in mobile view
  onCloseMobileModal() {
    this.setState({ isMobileModalOpen: false });
  }

  render() {
    const {
      intl,
      listings,
      filterConfig,
      sortConfig,
      history,
      location,
      mapListings,
      onManageDisableScrolling,
      pagination,
      scrollingDisabled,
      searchInProgress,
      searchListingsError,
      searchParams,
      activeListingId,
      onActivateListing,
      // user,FinalForm
      currentUser,
      isAuthenticated,
      userNativeLang,
      isMobileLayoutFinalForm,
      onUpdateProfile,
      onSearchListings,
      workingStaffs,
      AppliedStaffs,
      AppliedStaffsListing,
      currentWorkerAssignedNotification,
    } = this.props;

    const userJobCategory = currentUser?.attributes?.profile?.publicData?.jobCategories?.map(
      c => c.category
    );
    const currentWorkerAddress = currentUser?.attributes?.profile?.publicData?.workerAddress;

    if (
      (currentUser && currentUser?.attributes?.profile?.publicData?.isProvider) ||
      !isAuthenticated
    ) {
      history.push(createResourceLocatorString('NotFoundPage', routeConfiguration(), {}, {}));
      return null;
    }
    // eslint-disable-next-line no-unused-vars
    const { mapSearch, page, ...searchInURL } = parse(location.search, {
      latlng: ['origin'],
      latlngBounds: ['bounds'],
    });

    // urlQueryParams doesn't contain page specific url params
    // like mapSearch, page or origin (origin depends on config.sortSearchByDistance)
    const urlQueryParams = pickSearchParamsOnly(searchInURL, filterConfig, sortConfig);

    // Page transition might initially use values from previous search
    const urlQueryString = stringify(urlQueryParams);
    const paramsQueryString = stringify(
      pickSearchParamsOnly(searchParams, filterConfig, sortConfig)
    );
    const searchParamsAreInSync = urlQueryString === paramsQueryString;

    const validQueryParams = validURLParamsForExtendedData(searchInURL, filterConfig);

    const isWindowDefined = typeof window !== 'undefined';
    const isMobileLayout = isWindowDefined && window.innerWidth < MODAL_BREAKPOINT;
    const shouldShowSearchMap =
      !isMobileLayout || (isMobileLayoutFinalForm && this.state.isSearchMapOpenOnMobile);

    const onMapIconClick = () => {
      this.useLocationSearchBounds = true;
      this.setState({ isSearchMapOpenOnMobile: true });
    };

    const { address, bounds, origin } = searchInURL || {};
    const { title, description, schema } = createSearchResultSchema(listings, address, intl);

    // Set topbar class based on if a modal is open in
    // a child component
    const search = parse(location.search);

    const displayName = currentUser?.attributes.profile.displayName;
    const customId = currentUser?.attributes?.profile?.publicData?.customId;
    const isEmailVerified = currentUser?.attributes?.emailVerified;
    const rawJobSector = currentUser?.attributes?.profile?.publicData?.jobCategories;

    const isProvider = currentUser?.attributes?.profile?.publicData?.isProvider;
    const jobCategoryOptions = findOptionsForSelectFilter('category', filterConfig) || [];
    const jobSubCategoryOptions = findOptionsByFilterLabel('Subcategory', filterConfig) || {};
    
    // Filter out invalid categories that are no longer in the config (e.g., commented out construction)
    const validCategoryKeys = Array.isArray(jobCategoryOptions) ? jobCategoryOptions.map(opt => opt?.key).filter(Boolean) : [];
    
    const jobSector = rawJobSector && validCategoryKeys.length > 0
      ? rawJobSector.filter(job => {
          const categoryValue = typeof job.category === 'object' && job.category?.value 
            ? job.category.value 
            : job.category;
          return validCategoryKeys.includes(categoryValue);
        })
      : rawJobSector || [];
    const reducedJobSubCategory = Object.values(jobSubCategoryOptions).reduce(
      (sum, curr) => [...sum, ...curr],
      []
    );

    const asideJobSectorName = jobSector
      ? jobCategoryOptions
          .filter(f => jobSector?.find(({ category }) => category === f?.value))
          .map(m => m.label[userNativeLang])
      : undefined;
    const asideJobSectorSubCategoryName = jobSector
      ? reducedJobSubCategory
          .filter(f => jobSector.find(({ subCategory }) => subCategory === f?.value))
          .map(m => m.label[userNativeLang])
      : undefined;

    const paginationLinks =
      pagination && pagination.totalPages > 1 ? (
        <PaginationLinks
          className={css.pagination}
          pageName="SearchPage"
          pageSearchParams={search}
          pagination={pagination}
        />
      ) : null;
    const priceData = (price, intl) => {
      if (price && price.currency === config.currency) {
        const formattedPrice = formatMoney(intl, price);

        return { formattedPrice, priceTitle: formattedPrice };
      } else if (price) {
        return {
          formattedPrice: intl.formatMessage(
            { id: 'ListingCard.unsupportedPrice' },
            { currency: price.currency }
          ),
          priceTitle: intl.formatMessage(
            { id: 'ListingCard.unsupportedPriceTitle' },
            { currency: price.currency }
          ),
        };
      }
      return {};
    };
    function calculateProgress(data) {
      const email = data?.attributes?.email;
      // const  {email}  = data?.attributes;
      const firstName = data?.attributes?.profile?.firstName;
      const lastName = data?.attributes?.profile?.lastName;
      const age16Plus = data?.attributes?.profile?.publicData?.age16Plus;
      const drivingLicense = data?.attributes?.profile?.publicData?.drivingLicense;
      const {
        // age16Plus,
        // drivingLicense,
        jobCategories,
        jobExperiences,
        knownLanguages,
        permitsAndCertificates,
        preferredLang,
        references,
        workerAddress,
        workerAgrement,
        workerAllowed,
      } = data?.attributes?.profile?.publicData || {};

      const relevantFields = [
        firstName,
        lastName,
        age16Plus,
        drivingLicense,
        jobCategories?.length > 0,
        jobExperiences?.length > 0,
        knownLanguages?.length > 0,
        permitsAndCertificates?.length > 0,
        preferredLang,
        references?.length > 0,
        workerAddress,
        workerAgrement?.length > 0,
        workerAllowed,
        email,
      ];

      const completedFields = relevantFields.filter(
        field => field !== null && field !== undefined && field !== false
      );
      const progress = (completedFields.length / relevantFields.length) * 100;

      return progress;
    }
    const progressData = calculateProgress(currentUser);
    const venueType = findOptionsForSelectFilter('venueType', config.custom.filters);
    const datePostedType = findOptionsForSelectFilter('datePosted', config.custom.filters);

    const isProfileVerified =
      currentUser?.attributes?.profile?.metadata?.isProfileVerified || false;
    const { interviewDetails } = currentUser?.attributes?.profile?.privateData || {};
    const asideContent = (
      <div className={css.asideContent}>
        <div className={css.asideImgWrap}>
          <AvatarLarge className={css.avatar} user={currentUser} disableProfileLink />
          <div className={css.asidetxtWrap}>
            {currentUser?.attributes?.profile?.firstName &&
            currentUser?.attributes?.profile?.lastName ? (
              <>
                <div className={css.asideWorkerName}>
                  <span>{currentUser?.attributes?.profile?.firstName}</span>
                  <span>{currentUser?.attributes?.profile?.lastName}</span>
                  {isProfileVerified && <VerifiedTickComponent />}
                </div>
              </>
            ) : null}

            {currentUser?.id && isProvider ? (
              <span className={css.customIdSpan}>
                <FormattedMessage
                  id="ProfileSettingsPage.businessID"
                  values={{ customId: customId }}
                />
                {customId}
              </span>
            ) : (
              <span className={css.customIdSpan}>
                {/* <FormattedMessage id="ProfileSettingsPage.workerID" values={customId} /> */}
                <FormattedMessage id="ProfileSettingsPage.workerID" />
                <div className={css.idCopyDiv}>
                  <span className={css.customId}>{customId && customId.toUpperCase()}</span>
                  <span>
                    <CopyToClipBoard copiedText={customId} />
                  </span>
                </div>

                {/* {customId} */}
              </span>
            )}
          </div>
          <button
            className={css.downArrowDiv}
            type="button"
            onClick={() =>
              this.setState(prevState => ({ asideDetailShow: !prevState.asideDetailShow }))
            }
          >
            <DownArrow />
          </button>
        </div>
        <div
          className={classNames(css.workerdtlsdesk, {
            [css.workerdtlsmob]: !this.state.asideDetailShow,
          })}
        >
          <div className={css.profileCompleteSliderDiv}>
            <span>
              {' '}
              <FormattedMessage id="SearchPage.ProgressbarHeading" />{' '}
            </span>
            <div className={css.sliderContainer}>
              <div className={css.lightSlider}>
                <div className={css.DeepSlider} style={{ width: `${progressData}%` }}></div>
              </div>
              <span>{Math.round(progressData)}%</span>
              {/* <span>{progressData.toFixed()}%</span> */}
            </div>
          </div>
          <div className={css.asideContactInfoHeadingWrapper}>
            <div className={css.asideContactInfoHeading}>
              <FormattedMessage id="ProfilePage.ContactInformationAsideHeading" />
            </div>
            <span className={css.lineAsideHeading}></span>
          </div>
          {currentUser?.attributes?.profile?.protectedData?.phoneNumber ? (
            <div className={css.AsideContainerDiv}>
              <span className={css.subheadingAside}>
                <FormattedMessage id="ProfilePage.PhonenumberAside" />
              </span>
              {/* <div className={css.asideName}> */}
              <div className={css.asideName}>
                <span>
                  {currentUser?.attributes?.profile?.protectedData?.phoneNumber.dialCode}-
                  {currentUser?.attributes?.profile?.protectedData?.phoneNumber.number.replace(
                    /(\d{3})(\d{3})(\d{4})/,
                    '$1-$2-$3'
                  )}{' '}
                </span>
              </div>
            </div>
          ) : null}

          {currentUser?.attributes?.email ? (
            <div className={css.AsideContainerDiv}>
              <span className={css.subheadingAside}>
                <FormattedMessage id="ProfilePage.EmailAside" />
              </span>
              <div className={css.asideName}>
                <div className={css.emailAsideRow}>
                  <span>{currentUser?.attributes?.email}</span>
                  {isEmailVerified ? (
                    <span>
                      <ThankYou className={css.ThankYouLogo} />
                    </span>
                  ) : null}
                </div>
              </div>
            </div>
          ) : null}
          {jobSector?.length > 0 ? (
            <div className={css.jobCategoriesAside}>
              <div className={css.asideContactInfoHeadingWrapper}>
                <div className={css.asideContactInfoHeading}>
                  {/* <FormattedMessage id="ProfilePage.ContactInformationAsideHeading" /> */}
                  <FormattedMessage id="SearchPage.JobSectorAsideHeading" />
                </div>
                <span className={css.lineAsideHeading}></span>
              </div>
              <span className={css.jobSectorDesc}>
                {' '}
                {/* {asideJobSectorName?.map((m, index) => {
                
                return `${asideJobSectorName.length - 1 === index ? m : m + ' , '}`;
              })} */}
                {jobSector.map((j, indx) => {
                  const categoryOption = jobCategoryOptions.find(f => j.category === f.value);
                  const subcategoryOption = reducedJobSubCategory.find(f => j.subCategory === f.value);
                  
                  // Skip rendering if category or subcategory not found
                  if (!categoryOption || !subcategoryOption) {
                    return null;
                  }
                  
                  return (
                    <React.Fragment key={indx}>
                      <span className={css.jobSectorAsidecategory}>
                        {categoryOption.label[userNativeLang]}
                      </span>
                      <br />
                      <span className={css.jobSectorsubcategory}>
                        {subcategoryOption.label[userNativeLang]}
                      </span>

                      {/* Per-category verification is retired — no verified/not-verified tag. */}
                      <br />
                    </React.Fragment>
                  );
                })}
              </span>
            </div>
          ) : null}
        </div>
      </div>
    );
    const searchPlaceholder = intl.formatMessage({
      id: 'Search.placeholder',
    });

    const getCurrentUserFavourites = async userId => {
      const currentUserFavourites = await axios.post(
        `${apiBaseUrl()}/api/currentuser-favourite-listings`,
        { userId },
        {
          withCredentials: true,
        }
      );
      return currentUserFavourites;
    };

    const handleSearchChange = e => {
      e.preventDefault();
      const searchValue = e.target.value;

      this.setState({ searchInput: searchValue });
    };

    const resolveSearchTab = () =>
      search.tab || this.state.currentTab || 'MostRecent';

    const handleClearSearch = () => {
      this.setState({ searchInput: '' });
      const { keywords, ...rest } = search;
      history.push(
        createResourceLocatorString('SearchPage', routeConfiguration(), {}, {
          ...rest,
          tab: resolveSearchTab(),
        })
      );
    };
    const handleSearch = () => {
      const searchItem = this.state.searchInput.trim().toLowerCase();
      const nextParams = {
        ...search,
        tab: resolveSearchTab(),
      };
      if (searchItem) {
        nextParams.keywords = searchItem;
      } else {
        delete nextParams.keywords;
      }

      history.push(
        createResourceLocatorString('SearchPage', routeConfiguration(), {}, nextParams)
      );
    };

    const mainContainer = (
      <div className={css.mainContainer}>
        <div className={css.searchContainer}>
          <input
            type="text"
            onChange={handleSearchChange}
            // value={search.keywords ? search.keywords : this.state.searchInput}
            value={this.state.searchInput}
            placeholder={searchPlaceholder}
          />
          {(this.state.searchInput && this.state.searchInput.trim() !== '') || search.keywords ? (
            <div className={css.clearSearchIcon}>
              <CloseIcon className={css.closeIcon} onClick={handleClearSearch} />
            </div>
          ) : null}

          <BiSearch className={css.search} onClick={handleSearch} />
        </div>
        <div className={css.mainContainerHeading}>
          <FormattedMessage id="SearchPage.JobsYouMightLike" />
        </div>
        <div className={css.tabContainer}>
          <span className={css.tabDiv}>
            {/* <button
              type="button"
              className={classNames(css.desktopReviewsTabNav, {
                // [css.selectedTab]: search?.tab === 'BestMatches',
                [css.selectedTab]:
                  this.state.currentTab === 'BestMatches' && search?.tab === 'BestMatches',
              })}
              onClick={async () => {
                this.setState({
                  currentTab: 'BestMatches',
                });
                // onSearchListings({ tab: 'BestMatches' });
                this.setState({ searchInput: '' });
                const params = { tab: 'BestMatches' };
                history.push(
                  createResourceLocatorString('SearchPage', routeConfiguration(), {}, params)
                );
              }}
            >
              <span className={css.tabText}>
                <FormattedMessage id="SearchPage.BestMatches" />
              </span>
            </button> */}
            <button
              type="button"
              className={classNames(css.desktopReviewsTabNav, {
                // [css.selectedTab]: search?.tab === 'MostRecent',
                [css.selectedTab]:
                  this.state.currentTab === 'MostRecent' || search?.tab === 'MostRecent',
              })}
              onClick={() => {
                this.setState({
                  currentTab: 'MostRecent',
                });
                // onSearchListings({ tab: 'MostRecent' });
                this.setState({ searchInput: '' });
                const params = { tab: 'MostRecent' };
                history.push(
                  createResourceLocatorString('SearchPage', routeConfiguration(), {}, params)
                );
              }}
            >
              <span className={css.tabText}>
                <FormattedMessage id="SearchPage.MostRecent" />
              </span>
            </button>

            {/* <button
              type="button"
              className={classNames(css.desktopReviewsTabNav, {
                // [css.selectedTab]: search?.tab === 'MostRecent',
                [css.selectedTab]:
                  this.state.currentTab === 'MostRecent' && search?.tab === 'MostRecent',
              })}
              onClick={() => {
                this.setState({
                  currentTab: 'MostRecent',
                });
                // onSearchListings({ tab: 'MostRecent' });
                this.setState({ searchInput: '' });
                const params = { tab: 'MostRecent' };
                history.push(
                  createResourceLocatorString('SearchPage', routeConfiguration(), {}, params)
                );
              }}
            >
              <span className={css.tabText}>
                <FormattedMessage id="SearchPage.MostRecent" />
              </span>
            </button> */}

            <button
              type="button"
              className={classNames(css.desktopReviewsTabNav, {
                // [css.selectedTab]: search?.tab === 'SavedJobs',
                [css.selectedTab]:
                  this.state.currentTab === 'SavedJobs' && search?.tab === 'SavedJobs',
              })}
              onClick={async () => {
                this.setState({
                  currentTab: 'SavedJobs',
                });
                this.setState({ searchInput: '' });
                const params = { tab: 'SavedJobs' };
                history.push(
                  createResourceLocatorString('SearchPage', routeConfiguration(), {}, params)
                );
                // await onSearchListings({
                //   ids: [currentUser?.attributes?.profile?.protectedData?.favourites],
                //   // page,
                //   tab: 'SavedJobs',
                //   perPage: 10,
                //   include: ['author', 'images'],
                //   'fields.listing': ['title', 'description', 'geolocation', 'price', 'publicData'],
                //   'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
                //   'fields.image': ['variants.landscape-crop', 'variants.landscape-crop2x'],
                //   'limit.images': 1,
                // }).then(res => {
                //   this.setState({ favlist: res?.data?.data });
                // });
              }}
            >
              <span className={css.tabText}>
                <FormattedMessage id="SearchPage.SavedJobs" />
              </span>
            </button>
            <button
              type="button"
              className={classNames(css.desktopReviewsTabNav, {
                // [css.selectedTab]: search?.tab === 'AppliedTab',
                [css.selectedTab]:
                  this.state.currentTab === 'AppliedTab' && search?.tab === 'AppliedTab',
              })}
              onClick={() => {
                this.setState({
                  currentTab: 'AppliedTab',
                });
                this.setState({ searchInput: '' });
                const params = { tab: 'AppliedTab' };
                history.push(
                  createResourceLocatorString('SearchPage', routeConfiguration(), {}, params)
                );
              }}
            >
              <span className={css.tabText}>
                <FormattedMessage id="SearchPage.AppliedJobs" />
              </span>
            </button>
          </span>
          <span className={css.advance} onClick={() => this.setState({ isAdvanceModalOpen: true })}>
            <FormattedMessage id="SearchPage.advanceFilter" />
          </span>
        </div>

        <div>
          {searchInProgress ? (
            <IconSpinner />
          ) :
          this.state.currentTab === 'MostRecent' ? (
            <>
              {listings?.length === 0 ? (
                <div className={css.noMatchFound}>
                  <>
                    <NoMatchFound />
                    <span>
                      <FormattedMessage id="SearchPage.noMatchFound" />
                    </span>

                    <div>
                      <NamedLink key="seeJobs" name="SearchPage">
                        {' '}
                        <span className={css.seeJobs}>
                          <FormattedMessage id="SearchPage.seeJobs" />
                        </span>{' '}
                      </NamedLink>
                    </div>
                  </>
                </div>
              ) : (
                <div className={css.TabItemContainer}>
                  <ListingCardCustom
                    listings={listings}
                    userNativeLang={userNativeLang}
                    isProvider={isProvider}
                    jobCategoryOptions={jobCategoryOptions}
                    jobSubCategoryOptions={jobSubCategoryOptions}
                    reducedJobSubCategory={reducedJobSubCategory}
                    intl={intl}
                    onUpdateProfile={onUpdateProfile}
                    currentUser={currentUser}
                    history={history}
                  />
                  <center> {paginationLinks}</center>
                </div>
              )}
            </>
          ) : this.state.currentTab === 'SavedJobs' ? (
            <>
              {listings?.length === 0 ? (
                <div className={css.noMatchFound}>
                  <>
                    <NoMatchFound />
                    <span>
                      <FormattedMessage id="SearchPage.noSavedGigFound" />
                    </span>

                    {/* <div>
                      <NamedLink key="seeJobs" name="SearchPage">
                        {' '}
                        <span className={css.seeJobs}>
                          <FormattedMessage id="SearchPage.seeJobs" />
                        </span>{' '}
                      </NamedLink>
                    </div> */}
                  </>
                </div>
              ) : (
                <>
                  <ListingCardCustom
                    listings={listings}
                    userNativeLang={userNativeLang}
                    isProvider={isProvider}
                    jobCategoryOptions={jobCategoryOptions}
                    jobSubCategoryOptions={jobSubCategoryOptions}
                    reducedJobSubCategory={reducedJobSubCategory}
                    intl={intl}
                    onUpdateProfile={onUpdateProfile}
                    currentUser={currentUser}
                    history={history}
                    search={search}
                  />
                  <center> {paginationLinks}</center>
                </>
              )}
            </>
          ) : this.state.currentTab === 'AppliedTab' ? (
            <>
              {listings?.length === 0 ? (
                <div className={css.noMatchFound}>
                  <>
                    <NoMatchFound />
                    <span>
                      <FormattedMessage id="SearchPage.noAppliedJobFound" />
                    </span>
                  </>
                </div>
              ) : (
                <>
                  <ListingCardCustom
                    listings={listings}
                    userNativeLang={userNativeLang}
                    isProvider={isProvider}
                    jobCategoryOptions={jobCategoryOptions}
                    jobSubCategoryOptions={jobSubCategoryOptions}
                    reducedJobSubCategory={reducedJobSubCategory}
                    intl={intl}
                    onUpdateProfile={onUpdateProfile}
                    currentUser={currentUser}
                    history={history}
                    search={search}
                  />
                  <center> {paginationLinks}</center>
                </>
              )}
            </>
          ) : null}
        </div>
      </div>
    );

    const topbarClasses = this.state.isMobileModalOpen
      ? classNames(css.topbarBehindModal, css.topbar)
      : css.topbar;

    // N.B. openMobileMap button is sticky.
    // For some reason, stickyness doesn't work on Safari, if the element is <button>
    return (
      <Page
        scrollingDisabled={scrollingDisabled}
        description={description}
        title={title}
        schema={schema}
      >
        {/* <TopbarContainer
          className={topbarClasses}
          currentPage="SearchPage"
          currentSearchParams={urlQueryParams}
        /> */}

        {/* <div className={css.container}>
            <MainPanel
              urlQueryParams={validQueryParams}
              listings={listings}
              searchInProgress={searchInProgress}
              searchListingsError={searchListingsError}
              searchParamsAreInSync={searchParamsAreInSync}
              onActivateListing={onActivateListing}
              onManageDisableScrolling={onManageDisableScrolling}
              onOpenModal={this.onOpenMobileModal}
              onCloseModal={this.onCloseMobileModal}
              onMapIconClick={onMapIconClick}
              pagination={pagination}
              searchParamsForPagination={parse(location.search)}
              showAsModalMaxWidth={MODAL_BREAKPOINT}
              history={history}
            />
            <ModalInMobile
              className={css.mapPanel}
              id="SearchPage.map"
              isModalOpenOnMobile={this.state.isSearchMapOpenOnMobile}
              onClose={() => this.setState({ isSearchMapOpenOnMobile: false })}
              showAsModalMaxWidth={MODAL_BREAKPOINT}
              onManageDisableScrolling={onManageDisableScrolling}
            >
              <div className={css.mapWrapper}>
                {shouldShowSearchMap ? (
                  <SearchMap
                    reusableContainerClassName={css.map}
                    activeListingId={activeListingId}
                    bounds={bounds}
                    center={origin}
                    isSearchMapOpenOnMobile={this.state.isSearchMapOpenOnMobile}
                    location={location}
                    listings={mapListings || []}
                    onMapMoveEnd={this.onMapMoveEnd}
                    onCloseAsModal={() => {
                      onManageDisableScrolling('SearchPage.map', false);
                    }}
                    messages={intl.messages}
                  />
                ) : null}
              </div>
            </ModalInMobile>
          </div> */}
        {/* <Form onSubmit={()=>this.handleSubmit}> */}

        <Modal
          className={css.SrchFltrModal}
          id="ContactDetails.showAuthModal"
          isOpen={this.state.isAdvanceModalOpen}
          onClose={() => this.setState({ isAdvanceModalOpen: false })}
          scrollLayerClassName={css.modalScrollLayer}
          containerClassName={css.modalContainer1}
          contentClassName={css.modalContent}
          onManageDisableScrolling={onManageDisableScrolling}
          usePortal
        >
          <FinalForm
            {...this.props}
            initialValues={{
              most: search.most === 'relevant' ? userJobCategory : true,
              nearme: search.near ? [search.near] : null,
              workerAddress: {
                address: search?.searchAddress
                  ? // ? decodeURIComponent(search.searchAddress)
                    search.searchAddress
                  : undefined,
                postalCode:
                  typeof search.pub_searchPin === 'number'
                    ? search.pub_searchPin
                    : search.pub_searchPin
                    ? search?.pub_searchPin?.toUpperCase()?.replace(/[^A-Z0-9]/g, '')
                    : undefined,
              },
              hourRate: search.pub_searchPrice ? search.pub_searchPrice.split(',')[0] : null,
              workersEarnTip: search.pub_workersEarnTip ? [search.pub_workersEarnTip] : null,
              date: search.searchHour
                ? datePostedType.filter(f => f?.hours === search?.searchHour)[0].label[
                    userNativeLang
                  ]
                : datePostedType.filter(f => f.hours === null)[0].label[userNativeLang],
              venue: search.pub_venueTypeName ? search.pub_venueTypeName : null,
              jobCategories:
                search.pub_searchJobcategory || search.pub_searchJobsubCategory
                  ? [
                      {
                        category: search.pub_searchJobcategory.includes(':')
                          ? search.pub_searchJobcategory
                              ?.split(':')[1]
                              ?.split(',')
                              .map(
                                m =>
                                  jobCategoryOptions?.find(f => f?.value === m).label[
                                    userNativeLang
                                  ]
                              )
                              .toString()
                          : search.pub_searchJobcategory,
                        subCategory: search.pub_searchJobsubCategory,
                      },
                    ]
                  : [{ category: null, subCategory: null }],

              knownLanguages: search.pub_searchLanguage
                ? [{ language: search.pub_searchLanguage }]
                : [{ language: null }],
            }}
            mutators={{ ...arrayMutators }}
            onSubmit={this.handleAdvanceSubmit}
            render={fieldRenderProps => {
              const {
                className,
                currentUser,
                handleSubmit,
                intl,
                invalid,
                pristine,
                inProgress,
                rootClassName,
                form,
                formId,
                values,
                onUpdateProfile,
                initialValues,
                userNativeLang,
                history,
                jobCategories,
                isRequired,
                onSearchListings,
              } = fieldRenderProps;

              const [language, setLanguage] = useState(true);

              const jobCategoryId = formId ? `${formId}.jobCategories` : 'jobCategories';
              const workerAddressId = formId ? `${formId}.workerAddress` : 'workerAddress';
              const [modalSubCategoryOptions, setModalSubCategoryOptions] = useState([]);
              // date posted  position: fixed;
              top: 0;
              const datePostedLabel = intl.formatMessage({
                id: 'AdvanceModal.datePosted',
              });
              // const industryTypePlaceholder = intl.formatMessage({
              //   id: 'SignupForm.industryTypePlaceholder',
              // });
              const datePostedRequiredMessage = intl.formatMessage({
                id: 'SignupForm.datePostedRequiredMessage',
              });
              const dateRequired = validators.required(datePostedRequiredMessage);

              // worker address
              const jobLocationLabel = intl.formatMessage({
                id: 'AdvanceModal.jobLocationLabel',
              });
              const jobLocationPlaceholder = intl.formatMessage({
                id: 'AdvanceModal.jobLocationPlaceholder',
              });
              const postalLabel = intl.formatMessage({
                id: 'PayoutDetailsForm.postalCodeLabel',
              });
              const postalPlaceholder = intl.formatMessage({
                id: 'AdvanceModal.workerPostalPlaceholder',
              });
              const addressRequiredMessage = intl.formatMessage({
                id: 'AdvanceModal.addressRequiredMessage',
              });
              const addressRequired = validators.addressRequired(addressRequiredMessage);

              // Hourly Rate
              const hourlyRatePlaceholder = intl.formatMessage({
                id: 'advancemodal.hourlyRatePlaceholder',
              });

              // job category
              const jobCategoryLabel = intl.formatMessage({
                id: isRequired
                  ? 'FieldWorkerJobCateogry.jobCategoryRequiredLabel'
                  : 'FieldWorkerJobCateogry.jobCategoryLabel',
              });
              const jobCategoryPlaceholder = intl.formatMessage({
                id: 'FieldWorkerJobCateogry.jobCategoryPlaceholder',
              });
              const jobCategoryRequiredMessage = intl.formatMessage({
                id: 'FieldWorkerJobCateogry.jobCategoryRequired',
              });

              // const jobCategoryValidator =  validators.required(jobCategoryRequiredMessage)
              const jobCategoryValidator = isRequired
                ? validators.required(jobCategoryRequiredMessage)
                : null;

              // job sub category
              const jobSubcategoryLabel = intl.formatMessage({
                id: isRequired
                  ? 'FieldWorkerJobCateogry.jobSubcategoryRequiredLabel'
                  : 'FieldWorkerJobCateogry.jobSubcategoryLabel',
              });
              const jobSubcategoryPlaceholder = intl.formatMessage({
                id: 'FieldWorkerJobCateogry.jobSubcategoryPlaceholder',
              });

              const jobSubcategoryRequiredMessage = intl.formatMessage({
                id: 'FieldWorkerJobCateogry.jobSubcategoryRequired',
              });

              const submitInProgress = inProgress;
              const MostFieldSelected = Object.keys(values).includes('most');
              const workerAddress = Object.keys(values).includes('workerAddress');
              const hourRate = Object.keys(values).includes('hourRate');

              const submitDisabled =
                !values.venue &&
                typeof values?.date === 'string' &&
                values?.jobCategories[0]?.category === null &&
                values?.jobCategories[0]?.subCategory === null &&
                // !MostFieldSelected &&
                values?.most === true &&
                values?.workerAddress?.address === undefined &&
                values?.workerAddress?.postalCode === undefined &&
                !values.hourRate &&
                values.knownLanguages[0].language === null &&
                !values.workersEarnTip &&
                !values.nearme;

              return (
                <Form>
                  <div className={css.headingDiv}>
                    <div className={css.AdvanceFilterheading}>
                      <FormattedMessage id="SearchPage.advanceFilter" />
                    </div>
                    <CloseIcon onClick={() => this.setState({ isAdvanceModalOpen: false })} />
                  </div>
                  <div className={css.middleContent}>
                    <div className={css.sortby}>
                      <FormattedMessage id="AdvanceFilter.sortBy" />
                    </div>
                    <div className={css.radiobuttonContainer}>
                      <FieldRadioButton
                        id="mostrecentId"
                        name="most"
                        label={
                          <>
                            <FormattedMessage id="advancemodal.mostrecent" />
                          </>
                        }
                        value={true}
                        // onClick={() => {

                        //   if (values.most === true)
                        //     values.jobCategories[0].category = undefined;
                        // }}
                        onChange={() => {
                          form.change('most', true);
                          form.change('jobCategories', [{ category: null, subCategory: null }]);
                        }}
                        // showAsRequired={pristine}
                      />
                      <FieldRadioButton
                        id="mostrelevantId"
                        name="most"
                        label={
                          <>
                            <FormattedMessage id="advancemodal.mostrelevant" />
                          </>
                        }
                        value={userJobCategory ? JSON.stringify(userJobCategory) : ''}
                        onChange={() => {
                          form.change('most', userJobCategory);
                        }}
                        // showAsRequired={pristine}
                      />
                    </div>
                    <div className={css.checkBoxWrap}>
                      <FieldCheckbox
                        id="workersEarnTipId"
                        name="workersEarnTip"
                        label={
                          <>
                            <FormattedMessage id="advancemodal.tipsCheckBox" />
                          </>
                        }
                        value={'Yes'}
                        // onChange={() => {

                        //   form.change('workersEarnTip',  'Yes');
                        // }}
                      />
                    </div>
                    <div>
                      <FieldCustomSelect
                        id="date"
                        name="date"
                        userNativeLang={userNativeLang}
                        options={datePostedType}
                        label={datePostedLabel}
                        noOptionMsgId="FieldWorkerJobCateogry.jobSubcategoryNooptionMsg"
                        className={classNames(css.fieldContainer, textfield)}
                        errorClassName={errorTextField}
                        validate={dateRequired}
                      />
                    </div>
                    <div
                      className={classNames(css.jobCategoryDiv, {
                        [css.cateDis]: values.most !== true,
                      })}
                    >
                      <FieldWorkerJobCategory
                        formApi={form}
                        className={css.workerJobCategoryTitle}
                        id={jobCategoryId}
                        name="jobCategories"
                        userNativeLang={userNativeLang}
                        values={jobCategories}
                        isRequired={true}
                        fromDescriptionForm={true}
                        onCateChange={val => {
                          form.change('most', true);
                        }}
                        fromSearchPage={true}
                      />
                    </div>

                    {/* <div className={css.venueFieldDiv}>
                    <FieldCustomSelect
                      id="venueId"
                      name="venue"
                      userNativeLang={userNativeLang}
                      options={venueType}
                      label={
                        <>
                          <FormattedMessage id="AdvanceModal.venueType" />
                        </>
                      }
                      placeholder={
                        <>
                          <FormattedMessage id="AdvanceModal.VenuePlaceholder" />
                        </>
                      }
                      className={classNames(css.fieldContainer, textfield)}
                      errorClassName={errorTextField}
                      //   onChange={(e) => {
                      //    form.change('venue',e.value)
                      //  }}
                    />
                  </div> */}
                    <div className={css.addressDiv}>
                      <FieldAddress
                        id={workerAddressId}
                        name="workerAddress"
                        addressLabel={jobLocationLabel}
                        addressPlaceholder={jobLocationPlaceholder}
                        postalLabel={postalLabel}
                        postalPlaceholder={postalPlaceholder}
                        className={textfield}
                        // errorClassName={errorTextField}
                        // validate={addressRequired}
                        userNativeLang={userNativeLang}
                        onChange={e => {
                          form.change('nearme', null);
                          form.change('workerAddress', {
                            address: e.address,
                            postalCode: e.postalCode,
                          });
                        }}
                      />
                    </div>
                    <FieldCheckbox
                      id="nearMeId"
                      name="nearme"
                      label={
                        <>
                          <FormattedMessage id="advancemodal.nearme" />
                        </>
                      }
                      value="near"
                      onChange={e => {
                        form.change('nearme', e);
                        form.change('workerAddress', { address: undefined, postalCode: undefined });
                      }}
                    />
                    <div className={css.hourlyDiv}>
                      <FieldNumberInput
                        className={textfield}
                        id="hourlyRateId"
                        name="hourRate"
                        label={
                          <>
                            <FormattedMessage id="advancemodal.hourlyRate" />
                          </>
                        }
                        placeholder={hourlyRatePlaceholder}
                      />
                      {/* <PriceFilter
                      id="hourlyRateId"
                      label={
                        <>
                          <FormattedMessage id="advancemodal.hourlyRate" />
                        </>
                      }
                    /> */}
                    </div>

                    <div className={css.languageDiv}>
                      <FieldLanguagesKnown
                        formApi={form}
                        id={'knownLanguages'}
                        name="knownLanguages"
                        userNativeLang={userNativeLang}
                        // titleClassName={css.workerJobCategoryTitle}
                        // values={ e=>e}
                        languageLabel={intl.formatMessage({ id: 'AdvanceModal.languageKnown' })}
                        isRequired={true}
                        intl={intl}
                        language={language}
                        clearLanguage={this.state.clearLanguageSearch}
                      />
                    </div>
                  </div>

                  <div className={css.SearchBtnDiv}>
                    <Button
                      type="button"
                      className={classNames({
                        [css.fieldDisabled]:
                          // submitDisabled || this.state.cancelBtnClick ? true : false,
                          submitDisabled ? true : false,
                      })}
                      inProgress={submitInProgress}
                      disabled={submitDisabled}
                      onClick={() => {
                        this.setState({ isAdvanceModalOpen: false });
                        const categoryFilter =
                          values?.most !== true &&
                          values?.most?.length > 0 &&
                          `has_any:${values.most}`;
                        // : values.jobCategories[0]?.category;

                        const params =
                          values?.workerAddress?.origin?.lat && values?.workerAddress?.origin?.lng
                            ? {
                                tab: search?.tab,
                                most: values.most === true ? 'recent' : 'relevant',
                                pub_venueTypeName: values?.venue?.value,
                                pub_workersEarnTip:
                                  values?.workersEarnTip !== null ? values?.workersEarnTip : null,
                                // pub_searchKeys: values?.venue?.value,
                                // searchHour: values?.date?.hours ? values?.date?.hours : null,
                                pub_searchtime: values?.date?.hours
                                  ? `${moment()
                                      .subtract(values?.date?.hours, 'hours')
                                      .valueOf()},${moment().valueOf()}`
                                  : null,
                                // origin: values?.nearme
                                //   ? new LatLng(
                                //       currentWorkerAddress?.origin?.lat,
                                //       currentWorkerAddress?.origin?.lng
                                //     )
                                //   : null,

                                bounds: values.nearme
                                  ? locationBounds(
                                      new LatLng(
                                        currentWorkerAddress?.origin?.lat,
                                        currentWorkerAddress?.origin?.lng
                                      ),
                                      1000000
                                    )
                                  : values?.workerAddress
                                  ? locationBounds(
                                      new LatLng(
                                        values?.workerAddress?.origin?.lat,
                                        values?.workerAddress?.origin?.lng
                                      ),
                                      1000000
                                    )
                                  : undefined,
                                // address: values?.workerAddress?.address,
                                // // mostUrl:  values?.most === true ,
                                searchAddress: values?.workerAddress
                                  ? values?.workerAddress?.address
                                  : null,
                                // pub_searchPin: values?.workerAddress
                                //   ? values?.workerAddress?.postalCode
                                //       ?.trim()
                                //       ?.replace(/[,\s]/g, '')
                                //       ?.toLowerCase()
                                //   : null,
                                pub_searchPin:
                                  typeof values?.workerAddress?.postalCode === 'string'
                                    ? values?.workerAddress?.postalCode
                                        ?.trim()
                                        ?.replace(/[,\s]/g, '')
                                        ?.toLowerCase()
                                    : values?.workerAddress?.postalCode,
                                pub_searchJobcategory:
                                  categoryFilter || values.jobCategories[0]?.category,
                                pub_searchJobsubCategory: values?.jobCategories[0]?.subCategory,
                                pub_searchLanguage: values?.knownLanguages[0]?.language?.value,
                                pub_searchPrice: values?.hourRate
                                  ? `${parseFloat(values.hourRate)},`
                                  : undefined,
                              }
                            : {
                                tab: search?.tab || 'MostRecent',
                                most: values.most === true ? 'recent' : 'relevant',
                                pub_venueTypeName: values?.venue?.value,
                                pub_workersEarnTip:
                                  values?.workersEarnTip !== null ? values?.workersEarnTip : null,
                                // pub_searchKeys: values?.venue?.value,
                                searchHour: values?.date?.hours ? values?.date?.hours : null,
                                pub_searchtime: values?.date?.hours
                                  ? `${moment()
                                      .subtract(values?.date?.hours, 'hours')
                                      .valueOf()},${moment().valueOf()}`
                                  : null,
                                // origin: values?.nearme
                                //   ? new LatLng(
                                //       currentWorkerAddress?.origin?.lat,
                                //       currentWorkerAddress?.origin?.lng
                                //     )
                                //   : null,

                                bounds: values.nearme
                                  ? locationBounds(
                                      new LatLng(
                                        currentWorkerAddress?.origin?.lat,
                                        currentWorkerAddress?.origin?.lng
                                      ),
                                      1000000
                                    )
                                  : undefined,
                                near: values.nearme ? values.nearme : null,
                                // : values?.workerAddress
                                //   ? locationBounds(
                                //       new LatLng(
                                //         values?.workerAddress?.origin?.lat,
                                //         values?.workerAddress?.origin?.lng
                                //       ),
                                //       10000
                                //     )
                                //   : undefined,
                                // address: values?.workerAddress?.address,
                                // // mostUrl:  values?.most === true ,
                                searchAddress: values?.workerAddress
                                  ? values?.workerAddress?.address
                                  : null,
                                pub_searchPin:
                                  typeof values?.workerAddress?.postalCode === 'string'
                                    ? values?.workerAddress?.postalCode
                                        ?.trim()
                                        ?.replace(/[,\s]/g, '')
                                        ?.toLowerCase()
                                    : values?.workerAddress?.postalCode,

                                pub_searchJobcategory:
                                  categoryFilter || values.jobCategories[0]?.category,
                                pub_searchJobsubCategory: values?.jobCategories[0]?.subCategory,
                                pub_searchLanguage: values?.knownLanguages[0]?.language?.value,
                                pub_searchPrice: values?.hourRate
                                  ? `${parseFloat(values.hourRate)},`
                                  : undefined,
                              };

                        history.push(
                          createResourceLocatorString(
                            'SearchPage',
                            routeConfiguration(),
                            {},
                            params
                          )
                        );
                      }}
                    >
                      <FormattedMessage id="AdvanceModal.search" />
                    </Button>
                    <span
                      onClick={() => {
                        // form.change('jobCategories', [{ category: null, subCategory: null }]);
                        // form.change('workersEarnTip', null);
                        // form.change('venue', null);
                        // form.change('knownLanguages', [{ language: null }]);
                        // form.change('hourRate', null);
                        // form.change('workerAddress', {
                        //   address: null,
                        //   postalCode: null,

                        // });
                        this.setState(
                          {
                            clearLanguageSearch: true,
                          },
                          () => {
                            this.setState({ clearLanguageSearch: false });
                          }
                        );

                        Object.values(search).length !== 0
                          ? history.push(
                              createResourceLocatorString(
                                'SearchPage',
                                routeConfiguration(),
                                {},
                                { tab: search?.tab || 'MostRecent' }
                              )
                            )
                          : form.reset();

                        // history.push(
                        //   createResourceLocatorString('SearchPage', routeConfiguration(), {}, {})
                        // );
                      }}
                      className={css.cancelBtn}
                    >
                      <FormattedMessage id="FilterForm.clear" />
                    </span>
                  </div>
                </Form>
              );
            }}
          />
        </Modal>

        <LayoutSideNavigation className={css.searchpagemain}>
          <LayoutWrapperTopbar>
            <TopbarContainer
              className={topbarClasses}
              currentPage="SearchPage"
              currentSearchParams={urlQueryParams}
            />
          </LayoutWrapperTopbar>

          {/* <LayoutWrapperSideNav
            className={classNames(css.Searchlft, {
              [css.interviewlft]: currentUser && !isProvider && isProfileVerified,
            })}
          > */}
          {/* {asideContent} */}

          <WorkerDashboardSideWrapper
            currentTab="SearchPage"
            isProvider={isProvider}
            history={history}
            userId={currentUser?.id}
            className={classNames(css.Searchlft, {
              [css.interviewlft]: currentUser && !isProvider && isProfileVerified,
            })}
          />
          {/* </LayoutWrapperSideNav> */}

          <LayoutWrapperMain
            className={classNames(css.containerWrap, {
              [css.interviewrght]: currentUser && !isProvider && isProfileVerified,
            })}
          >
            {mainContainer}{' '}
          </LayoutWrapperMain>

          <LayoutWrapperFooter>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSideNavigation>
      </Page>
    );
  }
}

SearchPageComponent.defaultProps = {
  listings: [],
  mapListings: [],
  pagination: null,
  searchListingsError: null,
  searchParams: {},
  tab: 'listings',
  filterConfig: config.custom.filters,
  sortConfig: config.custom.sortConfig,
  activeListingId: null,
};

SearchPageComponent.propTypes = {
  listings: array,
  mapListings: array,
  onActivateListing: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  pagination: propTypes.pagination,
  scrollingDisabled: bool.isRequired,
  searchInProgress: bool.isRequired,
  searchListingsError: propTypes.error,
  searchParams: object,
  tab: oneOf(['filters', 'listings', 'map']).isRequired,
  filterConfig: propTypes.filterConfig,
  sortConfig: propTypes.sortConfig,

  // from withRouter
  history: shape({
    push: func.isRequired,
  }).isRequired,
  location: shape({
    search: string.isRequired,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const {
    currentPageResultIds,
    pagination,
    searchInProgress,
    searchListingsError,
    searchParams,
    searchMapListingIds,
    activeListingId,
    workingStaffs: workingStaffsRefs,
  } = state.SearchPage;

  const { isAuthenticated } = state.Auth;
  const AppliedStaffs = getMarketplaceEntities(state, workingStaffsRefs);
  const AppliedStaffsListing = AppliedStaffs?.map(m => m?.listing);
  const AppliedStaffsListingId = AppliedStaffs?.map(m => m?.listing?.id?.uuid);
  const pageListings = getListingsById(state, currentPageResultIds);
  const mapListings = getListingsById(
    state,
    unionWith(currentPageResultIds, searchMapListingIds, (id1, id2) => id1.uuid === id2.uuid)
  );
  const { currentUser, currentWorkerAssignedNotification } = state.user;

  const { userNativeLang } = state.UI;
  //  const { userId, userShowError, reviews, queryReviewsError } = state.ProfilePage;
  //  const userMatches = getMarketplaceEntities(state, [{ type: 'user', id: userId }]);
  // const user = userMatches.length === 1 ? userMatches[0] : null;
  // const search = parse(location.search);

  return {
    listings: pageListings,
    // listings:
    //  search?.tab === 'AppliedTab'
    //     ? AppliedStaffsListing
    //     : pageListings,
    mapListings,
    pagination,
    scrollingDisabled: isScrollingDisabled(state),
    searchInProgress,
    searchListingsError,
    searchParams,
    activeListingId,
    isAuthenticated,
    currentUser,
    // AppliedStaffsListing,
    // user,
    // userShowError,
    // reviews,
    // queryReviewsError,
    userNativeLang,
    currentWorkerAssignedNotification,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onActivateListing: listingId => dispatch(setActiveListing(listingId)),
  onUpdateProfile: data => dispatch(updateProfile(data)),
  onSearchListings: data => dispatch(searchListings(data)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const SearchPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(SearchPageComponent);

export default SearchPage;
